import { render, staticRenderFns } from "./OnHoldCustomer.vue?vue&type=template&id=7f7cb352"
import script from "./OnHoldCustomer.vue?vue&type=script&lang=js"
export * from "./OnHoldCustomer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f7cb352')) {
      api.createRecord('7f7cb352', component.options)
    } else {
      api.reload('7f7cb352', component.options)
    }
    module.hot.accept("./OnHoldCustomer.vue?vue&type=template&id=7f7cb352", function () {
      api.rerender('7f7cb352', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/shop/src/components/OnHoldCustomer.vue"
export default component.exports